import { Controller } from "@hotwired/stimulus"

// Archived settings stay in the DOM so a Turbo Stream can swap a row in or out
// without a reload; hiding them is a class on the grid, which also covers rows
// inserted later by archiving or restoring.
export default class extends Controller {
  static targets = ["checkbox"]
  static classes = ["hidden"]
  static values = { storageKey: { type: String, default: "settings:showArchived" } }

  connect() {
    this.apply(this.stored ?? false)
  }

  toggle(event) {
    const show = event.target.checked
    this.apply(show)
    try {
      localStorage.setItem(this.storageKeyValue, show ? "1" : "0")
    } catch {
      // Private browsing and blocked storage just lose the preference.
    }
  }

  apply(show) {
    this.element.classList.toggle(this.hiddenClass, !show)
    if (this.hasCheckboxTarget) this.checkboxTarget.checked = show
  }

  get stored() {
    try {
      const value = localStorage.getItem(this.storageKeyValue)
      return value === null ? null : value === "1"
    } catch {
      return null
    }
  }
}
